<script setup>
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableRowRounded from "@/components/global-themed/table/TableRowRounded.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import ApprovedByPill from "@/components/kit-activity-log/partials/ApprovedByPill.vue";
import ActivityTarget from "@/components/kit-activity-log/partials/ActivityTarget.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";

import useDates from "@/composables/useDates";
import {changeOrderBy, useKitActivityLogs} from "@/composables/kit-activity-logs/useKitActivityLogs";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
const {formattedDate} = useDates()
const {orderBy, orderDirection, kitActivityLogs, isPending} = useKitActivityLogs();
</script>

<template>
  <DataTable class="tw-w-full">
    <TableHeaderRow class="tw-grid-cols-16">
      <TableHeaderCell
        col-span="4"
        :order-by="orderBy"
        :order-direction="orderDirection"
        name="category"
        @order-changed="changeOrderBy"
      >
        <span>Target</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="6"
        :order-by="orderBy"
        :order-direction="orderDirection"
        name="subcategory"
        @order-changed="changeOrderBy"
      >
        <span>Change</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="3"
        :order-by="orderBy"
        :order-direction="orderDirection"
        name="created_by_id"
        @order-changed="changeOrderBy"
      >
        <span>Approved By</span>
      </TableHeaderCell>

      <TableHeaderCell
        col-span="3"
        :order-by="orderBy"
        :order-direction="orderDirection"
        name="created_at"
        @order-changed="changeOrderBy"
      >
        <span>Date</span>
      </TableHeaderCell>
    </TableHeaderRow>

    <div
      v-if="isPending"
      class="tw-bg-white tw-p-8 tw-rounded-lg"
    >
      <LoadingBlock />
    </div>

    <div
      v-else
      class="tw-flex tw-flex-col tw-gap-4 tw-text-neutral-900 tw-text-base tw-mt-8"
    >
      <ZeroContent v-if="kitActivityLogs?.length < 1">
        Looks like there are no changes to display.
      </ZeroContent>

      <TableRowRounded
        v-for="activityLog in kitActivityLogs"
        :key="activityLog.id"
        class="tw-grid-cols-16"
      >
        <TableCell
          col-span="4"
          class="tw-flex tw-items-center tw-gap-4"
        >
          <ActivityTarget
            :category="activityLog.category"
            :page="activityLog.page"
            :location="activityLog.location"
          />
        </TableCell>

        <TableCell col-span="6">
          {{ activityLog.subcategory }}
        </TableCell>

        <TableCell col-span="3">
          <ApprovedByPill
            :user="{name: activityLog.created_by}"
            :date="activityLog.created_at"
          />
        </TableCell>

        <TableCell col-span="3">
          {{ formattedDate(activityLog.created_at) }}
        </TableCell>
      </TableRowRounded>
    </div>
  </DataTable>
</template>
